<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M17.998 13.9999C19.6549 13.9999 20.998 12.6568 20.998 10.9999C20.998 9.34307 19.6549 7.99993 17.998 7.99993M12.8273 17.9999C12.4155 19.1651 11.3043 19.9999 9.99805 19.9999C8.34119 19.9999 6.99805 18.6568 6.99805 16.9999V15.4999M7.00024 6.49993V15.4999M17.998 4.36864V17.6312C17.998 18.3084 17.3392 18.7897 16.6941 18.5839L3.69409 14.4363C3.2795 14.304 2.99805 13.9188 2.99805 13.4836V8.51626C2.99805 8.08107 3.2795 7.69585 3.69409 7.56357L16.6941 3.41595C17.3392 3.21013 17.998 3.6915 17.998 4.36864Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
